import {
  SET_EDITING_ASSIGNED_CONTENT,
  RESET_EDITING_ASSIGNED_CONTENT,
  MARK_AS_TO_WATCH_EDITING_ASSIGNED_CONTENT,
  MARK_AS_WATCHED_EDITING_ASSIGNED_CONTENT,
  SET_ALL_MY_ASSIGNED_CONTENT,
  SET_UPDATED_CONTENT_IN_LIST,
  SET_CONTENT_TYPES,
  RESET_CURRENT_CONTENT,
  SET_RELATED_CONTENT,
} from "../actions/actionsTypes";
import { ASSIGNED, COMPLETED } from "../consts/assignedContentStatus";

const initialState = {
  contentTypes: [],
  editingAssignedContent: {
    statusId: 0,
  },
  editingContent: {
    contentId: 0,
  },
  relatedContent: [],
  allAssignedContent: {},
  resourceTypes: [],
};

export const contentReducer = (state = initialState, action) => {
  if (action.type === SET_EDITING_ASSIGNED_CONTENT) {
    const { assignedContent, content, resourceTypes } = action.payload;
    return {
      ...state,
      editingAssignedContent: { ...assignedContent },
      editingContent: { ...content },
      resourceTypes: [...resourceTypes],
    };
  }

  if (action.type === RESET_CURRENT_CONTENT) {
    return {
      ...state,
      editingContent: {
        contentId: 0,
      },
    };
  }

  if (action.type === RESET_EDITING_ASSIGNED_CONTENT) {
    const { editingAssignedContent, editingContent } = initialState;
    return {
      ...state,
      editingAssignedContent: { ...editingAssignedContent },
      editingContent: { ...editingContent },
    };
  }

  if (action.type === MARK_AS_WATCHED_EDITING_ASSIGNED_CONTENT) {
    return {
      ...state,
      editingAssignedContent: {
        ...state.editingAssignedContent,
        statusId: COMPLETED,
      },
    };
  }

  if (action.type === MARK_AS_TO_WATCH_EDITING_ASSIGNED_CONTENT) {
    return {
      ...state,
      editingAssignedContent: {
        ...state.editingAssignedContent,
        statusId: ASSIGNED,
      },
    };
  }

  if (action.type === SET_ALL_MY_ASSIGNED_CONTENT) {
    return {
      ...state,
      allAssignedContent: {
        ...action.payload.assignedContent.reduce(
          (acc, ac) => ({ ...acc, [ac.contentId]: ac }),
          {}
        ),
      },
    };
  }

  if (action.type === SET_UPDATED_CONTENT_IN_LIST) {
    const { assignedContent } = action.payload;
    const { editingAssignedContent } = initialState;

    return {
      ...state,
      editingAssignedContent: {
        ...editingAssignedContent,
        statusId: ASSIGNED,
      },
      allAssignedContent: {
        ...state.allAssignedContent,
        [assignedContent.contentId]: assignedContent,
      },
    };
  }

  if (action.type === SET_CONTENT_TYPES) {
    const { contentTypes } = action.payload;
    return {
      ...state,
      contentTypes,
    };
  }

  if (action.type === SET_RELATED_CONTENT) {
    const relatedContent = action.payload;
    return {
      ...state,
      relatedContent,
    };
  }

  return state;
};
